import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector, loginUser, clearState, setNeedFirstLoad } from './UserSlice';
import { useHistory } from 'react-router-dom';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Particles from "../../components/Particles";
import { styled } from '@mui/material/styles';

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="http://www.roadmatics.com/">
                Roadmatics Technologies Private Limited
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}


// Use styled components instead of makeStyles
const StyledDiv = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));

export default function SignIn() {

    const dispatch = useDispatch();
    const history = useHistory();
    //const classes = useStyles();

    const { isFetching, isSuccess, isError, errorMessage } = useSelector(userSelector);

    const [ilogusername, setIlogusername] = useState('');
    const [ilogpassword, setIlogpassword] = useState('');

    const onUserChange = e => setIlogusername(e.target.value);
    const onPasswordChange = e => setIlogpassword(e.target.value);

    //const [errors, setErrors] = useState({});


    function onSubmit(e) {
        e.preventDefault();
        //console.log("In loginuser callback", ilogusername, ilogpassword);
        dispatch(loginUser({ ilogusername, ilogpassword }));
    }

    useEffect(() => {
        //console.log("IN effect success", isSuccess);
        /*if (isError) {
            console.error(errorMessage);
            dispatch(clearState());
        }*/

        if (isSuccess) {
            dispatch(clearState());
            dispatch(setNeedFirstLoad(true));
            console.log("Authetication Success");
            history.push('/secured/livetracking');
        }
    }, [isError, isSuccess, dispatch, errorMessage, history]);


    return (
        <>

            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <StyledDiv>
                    <img src="/cuboid.png" alt="Girl in a jacket" width="257" height="237" />
                    <br />
                    <Typography component="h1" variant="h4" color="primary">
                        Roadmatics iLogistek 3.0
                    </Typography>
                    {isFetching && <CircularProgress disableShrink />}
                    {
                        isError &&
                        <div>
                            <Typography component="h6" variant="body1" color="secondary">
                                {errorMessage}
                            </Typography>
                            <Button
                                fullWidth
                                variant="contained"
                                    color="secondary"
                                onClick={() => dispatch(clearState())}
                            >
                                Try Again
                            </Button>
                        </div>
                    }
                    {
                        (!isFetching && !isError) &&

                        <form noValidate onSubmit={onSubmit}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    autoFocus
                                    id="username"
                                    label="Username"
                                    name="username"
                                    autoComplete="username"
                                    value={ilogusername}
                                    //error={errors.username ? true : false}
                                    onChange={onUserChange}
                                    type="text"
                                />
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    value={ilogpassword}
                                    //error={errors.password ? true : false}
                                    onChange={onPasswordChange}
                                />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                >
                                    Sign In
                            </Button>
                            </form>
                    }
                </StyledDiv>
                <Box mt={8}>
                    {/*Object.keys(errors).length > 0 && (
                        <div className="ui error message">
                            {Object.values(errors).map(value => (
                                <li key={value}>{value}</li>
                            ))}
                        </div>
                            )*/}
                </Box>
                <Box mt={8}>
                    <Copyright />
                </Box>
            </Container>
            <Particles type="cobweb" />
        </>
    );
}